import React from 'react'
import { StaticImage } from 'gatsby-plugin-image'

import AppStoreBadges from 'components/AppStoreBadges'
import Container from 'components/Container'
import Button from 'components/Button'
import { useAnalytics } from 'hooks'
import WhatsAppButton from 'components/WhatsAppButton'

export interface TalkToSpecProps {
  variant?: 'default' | 'alternative'
}

const TalkToSpec = ({ variant = 'default' }: TalkToSpecProps) => {
  const { fireEvent } = useAnalytics()

  // Disparo do evento de clique externo
  const fireAnalyticsEvent = () => {
    fireEvent('externalClick', {
      component: 'TalkToSpec',
      target: 'linkWhatsapp',
    })
  }

  if (variant === 'alternative') {
    return (
      <div className='bg-black/70 text-white rounded-b-3xl'>
        <Container className='flex flex-col py-12 xl:py-20 text-white justify-center items-center text-center'>
          <h3 className='font-semibold text-2xl'>Fique tranquilo!</h3>
          <p>Deixe a sua contabilidade com a Hubs.</p>

          <WhatsAppButton className='w-full sm:w-fit mt-5' onClick={() => fireAnalyticsEvent()}>
            <Button className='mt-2 w-full sm:w-fit'>Fale com um especialista</Button>
          </WhatsAppButton>
        </Container>
      </div>
    )
  }

  return (
    <div className='bg-black/70 text-white rounded-b-3xl'>
      <Container className='flex flex-col lg:flex-row gap-8 xl:gap-12 py-12 xl:py-20 text-white'>
        <div className='hidden lg:flex justify-center items-center w-full lg:w-1/2'>
          <StaticImage
            src='../../images/resources/topo-lp-5.png'
            alt='Imagem de uma pessoa sorrindo enquanto segura e aponta para um telefone com a logo da Hubs Contabilidade'
            className='w-[450px] xl:w-[650px]'
            placeholder='blurred'
            quality={100}
          />
        </div>

        <div className='flex flex-col gap-8 md:gap-16 w-full lg:w-1/2 justify-center'>
          <div className='flex flex-col gap-4 text-center md:text-left'>
            <h3 className='font-semibold text-2xl'>Fique tranquilo!</h3>
            <p>Deixe a sua contabilidade com a Hubs.</p>

            <p>
              Você pode ter o controle completo da sua empresa, em qualquer momento e lugar que desejar, enquanto desfruta da tranquilidade
              de saber que nosso atendimento personalizado está à sua disposição para ajudá-lo e esclarecer todas as suas dúvidas.
            </p>

            <WhatsAppButton className='w-full sm:w-fit' onClick={() => fireAnalyticsEvent()}>
              <Button className='mt-2 w-full sm:w-fit'>Fale com um especialista</Button>
            </WhatsAppButton>
          </div>
          <div className='flex flex-col gap-4 text-center md:text-left'>
            <h3 className='font-semibold text-2xl'>
              <span className='font-semibold text-2xl'>Com nosso aplicativo inteligente</span> você tem tudo que precisa!
            </h3>

            <p>
              Com nosso aplicativo você pode ter tudo em um único lugar para consultar e controlar sua empresa sempre que precisar, na hora
              que você quiser.
            </p>

            <AppStoreBadges className='flex justify-around md:justify-start md:gap-4 mt-4' />
          </div>
        </div>
      </Container>
    </div>
  )
}

export default TalkToSpec
